import { useNavigate } from "react-router-dom";
import PageHeader from "../PageHeader";
import SnippetForm from "./SnippetForm";
import { snippetApi } from "../../services/api";

function CreateSnippet() {
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    const response = await snippetApi.create(data);
    navigate(`/snippets/${response.data.slug}`);
  };

  const handleCancel = () => navigate("/snippets");

  return (
    <div className="page-container mt-6 pt-4" style={{ maxWidth: 880 }}>
      <PageHeader
        title="New snippet"
        subtitle="Save a piece of text, markdown, or code"
      />
      <SnippetForm
        submitLabel="Create"
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
}

export default CreateSnippet;
